//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectBody.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectEdge.js";
import "../no/SelectFaceList.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"ConnectionType",1,0],[1,"DraftAngle",0,"Expression",0],[1,"DraftOffset",0,"Expression",0],[0,"DraftType",1,0],[0,"EndFaceType",1,0],[1,"FlangeBoundary",0,"SelectBody",0],[1,"FlangeSketchData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[1,"LimitGeometry",0,"SelectDisplayableObject",0],[0,"LimitType",1,0],[1,"Offset",0,"Expression",0],[1,"PlacementEdge",0,"SelectEdge",0],[1,"PlacementFaces",0,"SelectFaceList",0],[0,"Plane",1,"Plane",0],[0,"SelectionType",1,0],[1,"ShearAngle",0,"Expression",0],[1,"TiltAngle",0,"Expression",0],[1,"ToeSketchData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[1,"WebSketchData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0]],[[["endcutFace"],"InheritParametersFromEndcutFace",{},1,0],[["tEntity"],"UpdateContextEntity",{},1,0],[["otherBuilder"],"CopyBuilderData",{},1,0]],[]];
SPLM.Features.ShipDesign.EndCutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.EndCutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.EndCutBuilder.SelectionTypes = Object.freeze({
    "FacesWithAttributes" : "FacesWithAttributes", "FaceAndEdge" : "FaceAndEdge"});

SPLM.Features.ShipDesign.EndCutBuilder.LimitTypes = Object.freeze({
    "Value" : "Value", "Plane" : "Plane", "NeatTrim" : "NeatTrim"});

SPLM.Features.ShipDesign.EndCutBuilder.DraftTypes = Object.freeze({
    "Trim" : "Trim", "Extend" : "Extend"});

SPLM.Features.ShipDesign.EndCutBuilder.ConnectionTypes = Object.freeze({
    "Connected" : "Connected", "FlangeFree" : "FlangeFree", "Sniped" : "Sniped", "SnipedSquare" : "SnipedSquare", "None" : "None"});

SPLM.Features.ShipDesign.EndCutBuilder.EndFaceTypes = Object.freeze({
    "SquareCut" : "SquareCut", "NeatTrim" : "NeatTrim"});

export default SPLM;